import { ableTheme } from './able';

export const theme = ableTheme;
